import { SensorsDetails } from "./sensors";
import { VehicleDetails } from "./details";
import { Badge, Grid, Typography } from "@mui/material";
import moment from "moment";
import "moment-timezone";
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import styles from "./DetailsModal.module.scss";
import { Modal } from "../../modal";
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import { VehicleAllStateIcons } from "./vehicleAllStateIcons";
import { Button } from "antd";

moment.tz.setDefault("America/Sao_Paulo");

export const DetailsModal = ({
  open,
  handleOnClose,
  nonMonitored,
  vehicleDetails,
  openModalAlarms,
  openModalMap,
  openSensorsChartModal,
  openOccurrenceModal,
  setSensorSelectedToChart,
  setSensorDataToChart,
  vehicleDetailsTimer,
}) => {
  return (
    <Modal
      width={680}
      height={520}
      className={styles.detailsModal}
      open={open}
      onClose={handleOnClose}
      title={`Detalhes`}
    >
      <Grid container sx={{ minHeight: "100%" }}>
        <Grid item xs={12} className={styles.detailsContainer}>
          <Grid item xs={12} p={0.5}>
            <VehicleDetails vehicleDetails={vehicleDetails} />
          </Grid>
          <Grid item xs={12} p={0.5}>
            <VehicleAllStateIcons
              numberOfEvents={vehicleDetails.numberOfEvents}
              driverAwareness={vehicleDetails.isDriverAware}
              door={vehicleDetails.isDoorOpen}
              ignition={vehicleDetails.isIgnitionActivated}
              thermoKing={vehicleDetails.thermoKing}
              isAlarmActived={vehicleDetails.isAlarmActived}
              speed={vehicleDetails.vehicleSpeed}
              battery={vehicleDetails.powerVoltage}
            />
          </Grid>
          <Grid item xs={12} p={0.5} className={styles.sensorsContainer}>
            <SensorsDetails
              openOccurrenceModal={openOccurrenceModal}
              openSensorsChartModal={openSensorsChartModal}
              setSensorSelectedToChart={setSensorSelectedToChart}
              setSensorDataToChart={setSensorDataToChart}
              vehicleDetails={vehicleDetails}
              isNonMonitored={nonMonitored}
              vehicleDetailsTimer={vehicleDetailsTimer}
            />
          </Grid>
          <Grid item xs={12} className={styles.buttons}>
            <Button
              onClick={() => openModalAlarms()}
              type={"primary"}
              size={"middle"}
              style={{ background: "#D21717", color: "white" }}
              icon={
                <Badge
                  color="primary"
                  showZero
                  badgeContent={vehicleDetails.numberOfEvents}
                  max={99}
                >
                  <NotificationsRoundedIcon
                    style={{ color: "white", fontSize: "20px" }}
                  />
                </Badge>
              }
              iconPosition={"end"}
            >
              Alarmes Disparados
            </Button>
            <Button
              onClick={() => openModalMap()}
              type={"primary"}
              iconPosition={"end"}
              icon={<LocationOnRoundedIcon style={{ fontSize: "18px" }} />}

              style={{
                background: "#E4A600",
                color: "white",
                marginLeft: "12px",
                display: 'flex',
                alignItems: 'center'
              }}
            >
              Ver no Mapa
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <Typography
        style={{
          float: "right",
          marginTop: "auto",
          fontSize: "13px",
        }}
        component="span"
        variant="body2"
      >
        Atualizado em{" "}
        {moment(vehicleDetails.lastUpdate).format("DD/MM/YYYY HH:mm:ss")}
      </Typography>
    </Modal>
  );
};
